import { isWeChatBrowser } from "./browser";
import { getCurrentDomain } from "./url";

const isSubDevSubPlatform = (domainOrEndpoint: string = getCurrentDomain()): boolean =>
    !!domainOrEndpoint && domainOrEndpoint.includes("gpp01.com");

export const isLocalhost = (domainOrEndpoint: string = getCurrentDomain()): boolean =>
    !!domainOrEndpoint && domainOrEndpoint.includes("localhost");

export const isCI = (domainOrEndpoint: string = getCurrentDomain()): boolean =>
    !!domainOrEndpoint && (domainOrEndpoint.includes("checkout.int") || domainOrEndpoint.includes("api.int"));

export const isDevServer = (domainOrEndpoint: string = getCurrentDomain()): boolean =>
    !!domainOrEndpoint && domainOrEndpoint.includes("gyro-n.money");

/**
 *
 * @param domain Current script or checkout domain. Does not support API endpoint as the same is used for both dev and stg
 */
export const isStaging = (domain: string = getCurrentDomain()): boolean =>
    !!domain && domain.startsWith("widget.gyro-n.money");

/**
 * @param domainOrEndpoint Current API domain or script domain. Default to the script domain or returns true when no domain is found
 */
export const isDevelop = (domainOrEndpoint: string = getCurrentDomain()): boolean =>
    !domainOrEndpoint ||
    isDevServer(domainOrEndpoint) ||
    isLocalhost(domainOrEndpoint) ||
    isCI(domainOrEndpoint) ||
    isSubDevSubPlatform(domainOrEndpoint);

export const FeatureFlag = {
    /**
     * Feature flag to not show the given feature the dev, local and test environments
     *
     * To use when a feature is still in early stages and can not be shown to QC
     */
    isUnderDevelopment: () => isDevelop() && !isStaging(),

    /**
     * Feature flags for feature in need of QC feedback before being released on production
     */
    isReadyForTesting: () => isDevelop(),

    linkFormRedirect: () => FeatureFlag.isReadyForTesting(),
    useWeChatWidget: () => FeatureFlag.isReadyForTesting() && isWeChatBrowser(),

    buttonBackgroundColorSplit: () => FeatureFlag.isUnderDevelopment(),
};
